import { useLaunchDarkly } from '@getaccept/lib-shared/src/launch-darkly/launch-darkly.composable';
import { AnalyticsCompanyTrait } from '@getaccept/lib-shared/src/types/analytics';
import { LaunchDarklyContextKind } from '@getaccept/lib-shared/src/launch-darkly/types/enums/launch-darkly-context-kind';
import { basicLogger } from 'launchdarkly-js-client-sdk';
import { useEntityStore } from './entity/store/entity.store';

export const loadLaunchDarkly = async (entityId?: string) => {
  const { initialize } = useLaunchDarkly();
  const entityStore = useEntityStore();

  const entityKey = entityStore.entity?.id || entityId;

  if (process.env.VUE_APP_LAUNCHDARKLY_KEY && entityKey) {
    initialize(
      process.env.VUE_APP_LAUNCHDARKLY_KEY,
      {
        kind: LaunchDarklyContextKind.Company,
        key: entityKey,
        [AnalyticsCompanyTrait.ID]: entityKey,
        [AnalyticsCompanyTrait.Name]: entityStore.entity?.name,
        [AnalyticsCompanyTrait.Plan]: entityStore.entity?.plan,
        [AnalyticsCompanyTrait.CountryCode]: entityStore.entity?.countryCode,
        [AnalyticsCompanyTrait.Language]: entityStore.entity?.language,
      },
      {
        bootstrap: 'localStorage',
        logger: basicLogger({ level: 'error' }),
      }
    );
  }
};
